<template>
  <div style="min-height: 100vh">
    <loading v-if="$store.state.loading"></loading>
    <div
      class=""
      v-if="
        $session.get('UserInfoNetPa').isEstelamSabtAhval.toString() == 'true' ||
        ($session.get('UserInfoNetPa').isEstelamSabtAhval.toString() =='false' &&
          IsrequiredEstelamSabtAhval == 'false')
      "
    >
      <net-pa-nav></net-pa-nav>
    </div>
    <div class="" v-else>
      <div class="container px-4">
        <user-info :NeedEstelam="'true'"></user-info>
      </div>
    </div>
    <a
      href="javascript:;"
      class="Button-Ticket Netpa-Shadow animated flash"
      @click="GoToCart()"
      v-if="GetCart > 0"
    >
      <div class="text-ticket mt-2">
        <i
          class="fas fa-shopping-bag text-light mt-3"
          style="font-size: 20px !important"
        ></i>
        <p class="text-light mr-1 d-inline">{{ GetCart }}</p>
      </div>
    </a>
    <modal-custom>
      <template v-slot:ContentModalOrange>
        <debtor></debtor>
      </template>
    </modal-custom>
    <button id="goTop"><i class="fas fa-arrow-up"></i></button>
    <span id="pageYOffset" style="display: none"
      ><span id="position" style="display: none"></span
    ></span>
  </div>
</template>
<script>
import Debtor from "./CmpNetPa/Debtor.vue";
import ModalCustom from "./Tools/ModalCustom.vue";
import NetPaNav from "./Tools/NetPa/NetPaNav.vue";
import loading from "./Tools/NetPa/Loading.vue";
import UserInfo from "./CmpNetPa/UserInfo.vue";
export default {
  data() {
    return {
      IsrequiredEstelamSabtAhval: false,
    };
  },
  components: {
    NetPaNav,
    ModalCustom,
    Debtor,
    loading,
    UserInfo,
  },
  created() {
    this.IsrequiredEstelamSabtAhval =
      this.$GetIsrequiredEstelamSabtAhval() == ""
        ? "false"
        : this.$GetIsrequiredEstelamSabtAhval();
  },
  mounted() {
    this.$displayTimer();
    this.$scrollToTop();
    let bootstrap = document.createElement("script");
    bootstrap.setAttribute("src", "/Template/NewMenu/js/bootstrap.bundle.js");
    document.head.appendChild(bootstrap);

    let custom = document.createElement("script");
    custom.setAttribute("src", "/Template/NewMenu/build/js/custom.js");
    document.head.appendChild(custom);
  },
  methods: {
    GoToCart() {
      if (this.$route.name != "Cart") {
        this.$router.push({ name: "Cart" });
      }
    },
  },
  computed: {
    GetCart() {
      var count = 0;
      let cart = this.$store.state.Netpa_Cart;
      for (let index = 0; index < cart.length; index++) {
        if (cart[index].item.length > 0) {
          count += cart[index].item.length;
        }
      }
      return count;
    },
  },
};
</script>
<style>
.bg-dark-Custom {
  background: #2a3f54 !important;
  /* border:1px solid #2A3F54 !important; */
}

h6 {
  font-size: 15px !important;
}

.no-wrap {
  white-space: nowrap;
}

.Netpa-Shadow {
  -webkit-box-shadow: 5px 5px 18px 4px rgba(0, 0, 0, 0.17);
  box-shadow: 5px 5px 18px 4px rgba(0, 0, 0, 0.17);
}

.Netpa-Shadow-2 {
  -webkit-box-shadow: 5px 5px 30px 4px rgba(0, 0, 0, 0.08);
  box-shadow: 5px 5px 30px 4px rgba(0, 0, 0, 0.08);
}

.NetPa-btn {
  border-radius: 15px !important;
}
#goTop {
  position: fixed;
  z-index: 999;
  left: 0;
  top: 95%;
  transform: translateY(-50%);
  padding: 15px;
  color: #fff;
  background: rgba(00, 00, 00, 0.3);
  border: none;
  opacity: 0;
  transition: opacity 0.4s linear;
}
#goTop.is-visible {
  opacity: 1;
}
</style>
<style>
.Button-Ticket {
  position: fixed;
  width: 36px;
  height: 80px;
  bottom: 50%;
  left: -3px;
  background-color: rgb(199, 40, 22);
  color: rgb(255, 255, 255);
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
  line-height: 60px;
  transition: 0.3s;
}
.Button-Ticket .text-ticket {
  transition: 0.3s;

  display: block;
  transform: rotate(90deg) !important;
}
.Button-Ticket:hover {
  width: 50px;
  transition: 0.3s;
  background-color: rgb(199, 40, 22);
  color: rgb(255, 255, 255);
}
.Button-Ticket:hover .text-ticket {
  margin-top: 25%;
  transition: 0.3s;
  color: rgb(255, 255, 255);
  transform: rotate(0) !important;
  font-size: 17px !important;
}
.animated.flip {
  -webkit-backface-visibility: visible;
  backface-visibility: visible;
  -webkit-animation-name: flip;
  animation-name: flip;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-iteration-count: infinite;
  animation-fill-mode: both;
}
@-webkit-keyframes flip {
  0% {
    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -360deg);
    transform: perspective(400px) rotate3d(0, 1, 0, -360deg);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  40% {
    -webkit-transform: perspective(400px) translate3d(0, 0, 150px)
      rotate3d(0, 1, 0, -190deg);
    transform: perspective(400px) translate3d(0, 0, 150px)
      rotate3d(0, 1, 0, -190deg);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  50% {
    -webkit-transform: perspective(400px) translate3d(0, 0, 150px)
      rotate3d(0, 1, 0, -170deg);
    transform: perspective(400px) translate3d(0, 0, 150px)
      rotate3d(0, 1, 0, -170deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  80% {
    -webkit-transform: perspective(400px) scale3d(0.95, 0.95, 0.95);
    transform: perspective(400px) scale3d(0.95, 0.95, 0.95);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  100% {
    -webkit-transform: perspective(400px);
    transform: perspective(400px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
}
@keyframes flip {
  0% {
    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -360deg);
    transform: perspective(400px) rotate3d(0, 1, 0, -360deg);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  40% {
    -webkit-transform: perspective(400px) translate3d(0, 0, 150px)
      rotate3d(0, 1, 0, -190deg);
    transform: perspective(400px) translate3d(0, 0, 150px)
      rotate3d(0, 1, 0, -190deg);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  50% {
    -webkit-transform: perspective(400px) translate3d(0, 0, 150px)
      rotate3d(0, 1, 0, -170deg);
    transform: perspective(400px) translate3d(0, 0, 150px)
      rotate3d(0, 1, 0, -170deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  80% {
    -webkit-transform: perspective(400px) scale3d(0.95, 0.95, 0.95);
    transform: perspective(400px) scale3d(0.95, 0.95, 0.95);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  100% {
    -webkit-transform: perspective(400px);
    transform: perspective(400px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
}
.flash {
  -webkit-animation-name: flash;
  animation-name: flash;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;

  animation-fill-mode: both;
}
@-webkit-keyframes flash {
  0%,
  50%,
  100% {
    opacity: 1;
  }

  25%,
  75% {
    opacity: 0;
  }
}

@keyframes flash {
  0%,
  50%,
  100% {
    opacity: 1;
  }

  25%,
  75% {
    opacity: 0;
  }
}
</style>
